import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { Validators } from '@angular/forms';

/**
 * Definição dos campos do formulário para o briefing de Website.
 * Atualizado para corresponder às imagens e usar RADIO_BUTTON para seleção única.
 */
export const WEBSITE_FORM_CONFIG: IFieldConfig[] = [
    // 1. Tipo de Projeto
    {
        type: TypeComponentFieldEnum.CHECKBOX,
        label: '1. O que você deseja criar? *',
        name: 'projectType',
        options: [
            { label: 'Site Institucional', value: 'institutional' },
            { label: 'Landing Page', value: 'landingPage' },
            { label: 'E-commerce', value: 'ecommerce' },
        ],
        validation: [Validators.required],
    },
    // 2. Objetivo Principal
    {
        type: TypeComponentFieldEnum.CHECKBOX,
        label: '2. Qual é o objetivo principal do site?',
        name: 'mainObjective',
        options: [
            { label: 'Apresentar a empresa/marca', value: 'branding' },
            { label: 'Gerar leads', value: 'leads' },
            { label: 'Vender produtos/serviços', value: 'sales' },
            { label: 'Informar e educar o público', value: 'informational' },
            { label: 'Outro:', value: 'other' },
        ],
        // Opcional marcar, mas campo Outro existe
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Se Outro, qual objetivo?', // Label ajustado para clareza
        name: 'mainObjectiveOther',
        placeholder: ' ',
        // Condicional
    },
    // 3. Público Alvo
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '3. Quem é o público-alvo do site? *',
        name: 'targetAudience',
        placeholder: 'Sua resposta',
        validation: [Validators.required],
    },
    // 4. Identidade Visual
    {
        type: TypeComponentFieldEnum.RADIO_BUTTON, // <<< ALTERADO
        label: '4. Já possui uma identidade visual definida?',
        name: 'hasBranding',
        options: [
            { label: 'Sim? Favor enviar logotipo, paleta de cores, fontes e outros materiais visuais.', value: 'yes' },
            { label: 'Não', value: 'no' },
        ],
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT_FILE,
        label: 'Anexar Arquivos da Identidade Visual (se Sim)', // Label ajustado
        name: 'brandingFiles',
        multiple: true, // Explicitamente permitir múltiplos arquivos
        accept: 'image/*,.pdf,.ai,.eps,.psd,.zip,.rar,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.svg,.mp4,.webp', // Expandir tipos aceitos
        // Condicional
    },
    // 5. Estilo Visual
    {
        type: TypeComponentFieldEnum.CHECKBOX,
        label: '5. Como você gostaria que o site fosse visualmente? *',
        name: 'visualStyle',
        options: [
            { label: 'Moderno', value: 'modern' },
            { label: 'Minimalista', value: 'minimalist' },
            { label: 'Sofisticado', value: 'sophisticated' },
            { label: 'Colorido e descontraído', value: 'colorful' },
            { label: 'Outro:', value: 'other' },
        ],
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Se Outro, qual estilo visual?',
        name: 'visualStyleOther',
        placeholder: ' ',
        // Condicional
    },
    // 6. Inspirações
    {
        type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
        label: '6. Exemplos de sites que você gosta (inspirações): deixe aqui as URLs:',
        name: 'inspirationUrls',
        placeholder: 'Sua resposta',
        // Opcional
    },
    // 7. Páginas Necessárias
    {
        type: TypeComponentFieldEnum.CHECKBOX,
        label: '7. Quais páginas ou seções o site deve ter? *',
        name: 'requiredPages',
        options: [
            { label: 'Página Inicial', value: 'home' },
            { label: 'Sobre Nós', value: 'about' },
            { label: 'Serviços/Produtos', value: 'services' },
            { label: 'Portfólio', value: 'portfolio' },
            { label: 'Blog', value: 'blog' },
            { label: 'Contato', value: 'contact' },
            { label: 'Loja Virtual', value: 'store' }, // <<< ADICIONADO
            { label: 'Outro:', value: 'other' },
        ],
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Se Outro, quais páginas?',
        name: 'pagesOther',
        placeholder: ' ',
        // Condicional
    },
    // 8. Funcionalidades Específicas
    {
        type: TypeComponentFieldEnum.CHECKBOX,
        label: '8. Funcionalidades Específicas: Marque as funcionalidades que o site deverá incluir: *',
        name: 'specificFeatures',
        options: [
            { label: 'Formulário de contato', value: 'contactForm' },
            { label: 'Integração com WhatsApp', value: 'whatsapp' },
            { label: 'Chat online', value: 'chat' },
            { label: 'Cadastro de e-mails para newsletter', value: 'newsletter' },
            { label: 'Blog integrado', value: 'blogIntegration' },
            { label: 'Integração com redes sociais', value: 'socialMedia' },
            { label: 'E-commerce com carrinho de compras e checkout', value: 'ecommerceFeatures' },
            { label: 'Área restrita para clientes ou membros', value: 'restrictedArea' },
            { label: 'SEO básico (otimização para motores de busca)', value: 'seoBasic' },
            { label: 'Multilíngue', value: 'multilingual' },
            { label: 'Google Maps integrado', value: 'googleMaps' },
            { label: 'Outro:', value: 'other' },
        ],
        validation: [Validators.required],
    },
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Se Outro, quais funcionalidades?',
        name: 'featureOther',
        placeholder: ' ',
        // Condicional
    },
    // 9. Conteúdo
    {
        type: TypeComponentFieldEnum.RADIO_BUTTON, // <<< ALTERADO
        label: '9. Você já possui o conteúdo do site (textos, imagens, vídeos)? *',
        name: 'hasContent',
        options: [
            { label: 'Sim, já possuo e enviarei o material.', value: 'yes' },
            { label: 'Não, preciso de ajuda para criação de conteúdo.', value: 'no_help_needed' },
        ],
        validation: [Validators.required],
    },
    // 10. Domínio e Hospedagem
    {
        type: TypeComponentFieldEnum.RADIO_BUTTON, // <<< ALTERADO
        label: '10. Já possui domínio e hospedagem?',
        name: 'hasDomainHosting',
        options: [
            { label: 'Sim', value: 'yes' },
            { label: 'Não', value: 'no' },
        ],
        validation: [Validators.required],
    },
];
